var map = {
	"./basketball.webp": 1665,
	"./bti-img.webp": 1666,
	"./bti-title-en.webp": 1667,
	"./cup.webp": 1668,
	"./football.webp": 1669,
	"./im-img.webp": 1670,
	"./im-title-en.webp": 1671,
	"./sb-img.webp": 1672,
	"./sb-title-cn.webp": 1673,
	"./sb-title-en.webp": 1674,
	"./sbo-img.webp": 1675,
	"./sbo-title-cn.webp": 1676,
	"./sbo-title-en.webp": 1677,
	"./sport-bg.webp": 1678,
	"./sport-ctg.webp": 1679,
	"./title-cn.webp": 1680,
	"./title-en.webp": 1681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 785;